import Box from '@paperstac/ui/lib/Box';
import React from 'react';

const defaultSx = {
  fontSize: 1,
  mb: 3,
  py: 2,
  px: 3,
  border: 'default',
  borderColor: 'red',
  borderRadius: 'corner',
  color: 'red',
};

const ErrorMessage = React.memo(({ sx = defaultSx, ...props }) => <Box sx={sx} {...props} />);

ErrorMessage.propTypes = {};

ErrorMessage.displayName = 'ErrorMessage';

export default ErrorMessage;
